export default class BillingPriceRecurringCreateRequest {
  public aggregateUsage: string;
  public interval: string;
  public intervalCount: number;
  public usageType: string;

  constructor(options) {
    this.aggregateUsage = options.aggregateUsage;
    this.interval = options.interval;
    this.intervalCount = options.intervalCount;
    this.usageType = options.usageType;
  }
}
